// extracted by mini-css-extract-plugin
export var boxItems = "_6x-1";
export var boxItemsLg = "_6x-2";
export var button = "_6x-7";
export var buttonLg = "_6x-8";
export var filterGroupBox = "_6x-0";
export var icon = "_6x-3";
export var iconSecondary = "_6x-6";
export var iconWrapper = "_6x-4";
export var iconWrapperLg = "_6x-5";